import { AccountMovementsViewModel } from "../../accounting/models/accounting-movement.model";

export class InvestmentFinancialModel {

  uid: string;
  accountingModelsNumber: string;
  accountingModelsId: number;
  filesInvestmentUid: string;
  isImage: boolean;
  isPdf: boolean;
  investmentValue: number;
  investmentDate: Date;
  investmentDescription: string;
  numberOfUnitsOrSharesInvested: number;
  percentageOfProfitabilityOrInterest: number;
  termInMonths: number;
  netBookValue: number;
  lastBalanceSheetDate: number; // Can be null
  generatesReturns: boolean;
  paided: string;
  manualMovement: AccountMovementsViewModel;

  constructor() {
    this.investmentValue = 0;
  }

}

export class InvestmentFinancialDepositsModel {

  uid: string;
  investmentsFinancialId: string;
  paymentCardsUid: string;
  bankAccountsUid: string;
  amount: number;
  depositDate: Date;
  typePay: string;
  commissions: number;
  bankAccountInfo: string;
  efectivoId: string;
  partnersId: number;
  polizaCreditoId: string;

  constructor() { }

}

